/**
 *
 * @param {*} author The author of the content {firstName, lastName, organization}
 * @returns A string. If Organization is present in the author object it will
 * be returned, otherwise return value will be 'Firstname Lastname'.
 * If there is no first & last name, will return null.
 */

const formatContentAuthor = (author) => {
  if (!author) return '';

  const { organization, firstName, lastName } = author;

  if (organization) {
    return organization;
  }

  if (!firstName && !lastName) {
    return null;
  }

  return `${firstName} ${lastName}`;
};

export default formatContentAuthor;
